import { useEffect, useState } from "react";

import { connect, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";

import { setHighlightedRowDomains } from "app/pages/sales-intelligence/modules/leads-search";
import { StyledExtensionIframeSidebar } from "app/pages/sales-intelligence/services/extension/style";
import { useExtensionIframe } from "app/pages/sales-intelligence/services/extension/useExtensionIframe";
import {
    setWidgetIdRightBar,
    toggleRightBar,
} from "app/pages/workspace/sales/sub-modules/common/store/action-creators";
import {
    selectRightBarIsOpen,
    selectWidgetIdRightBar,
} from "app/pages/workspace/sales/sub-modules/common/store/selectors";
import { resetOpportunitiesState } from "app/pages/workspace/sales/sub-modules/opportunities-lists/store/action-creators";
import { selectActiveWebsite } from "app/pages/workspace/sales/sub-modules/opportunities-lists/store/selectors";
import type { RootState, ThunkDispatchCommon } from "single-spa/store/types";

import type { BaseWebsiteType } from "../../types/similar-sites";

import { StyledOverlay } from "./styles";

export enum SidebarTrackingSectionName {
    List = "target accounts",
    LeadGen = "SI_find",
    SFConnector = "sfiframe",
}

type SidebarContainerProps = {
    isOpen: boolean;
    selectedWebsite: BaseWebsiteType;
    toggleRightSidebar: (isOpen: boolean) => void;
    trackingSectionName?: SidebarTrackingSectionName;
    widgetId: string;
    setWidgetIdSidebar: (widgetId: string | undefined) => void;
};

const SidebarContainer = (props: SidebarContainerProps) => {
    const { isOpen, toggleRightSidebar, selectedWebsite, trackingSectionName, setWidgetIdSidebar, widgetId } = props;
    const dispatch = useDispatch();

    const [isOverlayShown, setIsOverlayShown] = useState(false);

    const { iframeProps, updateDomain } = useExtensionIframe({
        urlParams: { mode: "pro-sidebar", trackingSectionName },
        onClose: () => {
            toggleRightSidebar(false);
            dispatch(setHighlightedRowDomains([]));
        },
    });

    const handleMouseOver = () => setIsOverlayShown(true);
    const handleMouseLeave = () => setIsOverlayShown(false);

    useEffect(() => {
        if (selectedWebsite?.domain) {
            updateDomain(selectedWebsite.domain, widgetId);
            setWidgetIdSidebar(undefined);
        }
    }, [widgetId, selectedWebsite, updateDomain, setWidgetIdSidebar]);

    useEffect(() => {
        return () => {
            dispatch(toggleRightBar(false));
            dispatch(resetOpportunitiesState());
            dispatch(setHighlightedRowDomains([]));
        };
    }, []);

    return iframeProps ? (
        <>
            {isOverlayShown && isOpen ? <StyledOverlay /> : null}
            <StyledExtensionIframeSidebar
                {...iframeProps}
                isOpen={isOpen}
                onMouseOver={handleMouseOver}
                onMouseLeave={handleMouseLeave}
            />
        </>
    ) : null;
};

const mapStateToProps = (state: RootState) => ({
    isOpen: selectRightBarIsOpen(state),
    selectedWebsite: selectActiveWebsite(state),
    widgetId: selectWidgetIdRightBar(state),
});

const mapDispatchToProps = (dispatch: ThunkDispatchCommon) => {
    return bindActionCreators(
        {
            toggleRightSidebar: toggleRightBar,
            setWidgetIdSidebar: setWidgetIdRightBar,
        },
        dispatch,
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SidebarContainer);
